import React from 'react'
import Zoom from 'react-reveal/Zoom'

import { SectionContainer, SectionText } from '../../_common'
import { Grid, Typography } from '@material-ui/core'

import { CgCheck } from 'react-icons/cg'
import useStyles from './styles'

const UsContent = () => {
  const { headline, bulletText, icon, list, bullet, iconWrapper } = useStyles()

  const bullets = [
    'Diseño, implementación y administración de planes de pensiones y retiro',
    'Planes de beneficios para empleados',
    'Valuación de pasivos derivados de las obligaciones laborales',
  ]

  return (
    <SectionContainer sectionID="usContent">
      <Typography className={headline}>
        Somos un grupo de profesionales en consultoría actuarial, laboral y
        patrimonial con <strong>más de 50 años de experiencia</strong> en:
      </Typography>
      <Zoom cascade>
        <ul className={list}>
          {bullets.map((e, i) => (
            <Grid key={i} container className={bullet}>
              <Grid item xs={1} className={iconWrapper}>
                <CgCheck className={icon} />
              </Grid>
              <Grid item xs={11}>
                <Typography className={bulletText}>{e}</Typography>
              </Grid>
            </Grid>
          ))}
        </ul>
      </Zoom>

      <SectionText
        regularBottom
        text="Contamos con corresponsales extranjeros y somos miembros activos y certificados del Colegio Nacional de Actuarios y de la Asociación Mexicana de Actuarios Consultores."
      />
      <SectionText
        text="Además, contamos con áreas especializadas de productos para compañías de
      seguros, manteniéndonos a la vanguardia mediante la actualización y la
      experiencia internacional."
      />
    </SectionContainer>
  )
}

export default UsContent
